import { PayloadAction } from '@reduxjs/toolkit'
import { put } from 'redux-saga/effects'
import { setStoreID } from 'store/features/sagaStore'

export function* setSagaStoreID(payload: PayloadAction<string>): Generator {
  try {
    yield put(setStoreID(payload.payload))
  } catch (e) {
    console.log(e)
  }
}
